module.exports = __webpack_public_path__ + "4bffc1cbcb0c5922131bd89ac4da97d6.jpg";